import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useTitle = (title: string) => {
    const [t] = useTranslation(['translation']);
    useEffect(() => {
        document.title = `${t('header-name')} - ${title}`;
    }, [t, title]);
};
